import { observer } from 'mobx-react';
import { FC, Fragment } from 'react';
import { FormError } from '@monorepo/base/src/components/form/form-error/form-error';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../../stores';
import { getUniqueFormErrorMessages } from '../../../utils/form-errors';
import styles from './campaign-form-errors.module.scss';

interface ICampaignFormErrors {
	isFormClicked: boolean;
}

export const CampaignFormErrors: FC<ICampaignFormErrors> = observer(({ isFormClicked }) => {
	const { campaignStore } = useStores<IAdminxStore>();
	const formStore = campaignStore.getCrud().getFormStore();
	const messages = getUniqueFormErrorMessages(formStore.getErrors());

	if (!isFormClicked || messages.length === 0) {
		return null;
	}

	return (
		<div className={styles.wrapper}>
			{messages.map(message => (
				<Fragment key={message}>
					<FormError msg={message} />
				</Fragment>
			))}
		</div>
	);
});
